import { createTheme } from '@mui/material';
import { grey } from '@mui/material/colors';
import { deepmerge } from '@mui/utils';
import { defaultTheme } from 'react-admin';

export const adminTheme = createTheme(
  deepmerge(defaultTheme, {
    components: {
      MuiTab: {
        styleOverrides: {
          root: {
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.04)',
            },
            flex: '1 1 auto',
            // Adjust this value as needed
            maxWidth: '10em',
          },
        },
      },
      MuiTabs: {
        styleOverrides: {
          flexContainer: {
            flexWrap: 'wrap',
          },
        },
      },
    },
    palette: {
      gray: grey,
    },
  }),
);
